module.exports = __webpack_public_path__ + "static/img/4.c762b5a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/zh/4.png
// module id = FNjI
// module chunks = 0